module.exports = __webpack_public_path__ + "img/kh.khe7fb0df.svg";